/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2024
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import Enum from './Enum';
//@import Enum (loadtime) // superclass

/**
 * <p>Java class for querySubjectUsage. <p>The following schema fragment specifies the expected content contained within this class. <p> <pre> &lt;simpleType name="querySubjectUsage"&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}NMTOKEN"&gt; &lt;enumeration value="automatic"/&gt; &lt;enumeration value="bridge"/&gt; &lt;enumeration value="summaryQuery"/&gt; &lt;/restriction&gt; &lt;/simpleType&gt; </pre>
 */
export default class QuerySubjectUsage extends Enum{

	enumValue = null;

	/**
	 * Specifies that the querySubject usage is automatic and therefore it will be computed by the planning code.
	 */
	static  AUTOMATIC = QuerySubjectUsage.newLiteral("automatic");

	/**
	 * Specifies that the querySubject refers to a bridge table.
	 */
	static  BRIDGE = QuerySubjectUsage.newLiteral("bridge");

	/**
	 * Specifies that the querySubject will be treated as a summaryQuery.
	 */
	static  SUMMARY_QUERY = QuerySubjectUsage.newLiteral("summaryQuery");



	constructor(v) {
		super(v);
		this.enumValue = v;
	}

	static fromValue(v) {
		for (var i = 0; (i < QuerySubjectUsage.values().length); ++i) {
			if (QuerySubjectUsage.values()[i].enumValue == v) {
				return QuerySubjectUsage.values()[i];
			}
		}
		throw new Error(v);
	}

	value() {
		return this.enumValue;
	}

	getResourceId() {
		return (("QuerySubjectUsage" + "_") + this.value());
	}
}


// WEBPACK FOOTER //
// ./src/generated/QuerySubjectUsage.js